export default {
  common: {
    inputText: 'Please enter ',
    selectText: 'Please select ',
    startTimeText: 'Start Time',
    endTimeText: 'End Time',
    login: 'Login',
    required: 'This item is required',
    loginOut: 'LoginOut',
    document: 'Document',
    profile: 'Profile',
    reminder: 'Reminder',
    loginOutMessage: 'Are you logged out of the system?',
    back: 'Back',
    ok: 'OK',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    reload: 'Reload',
    success: 'Success',
    closeTab: 'Close tab',
    closeTheLeftTab: 'Close the left tab',
    closeTheRightTab: 'Close the right tab',
    closeOther: 'Close other',
    closeAll: 'Close all',
    prevLabel: 'Previous',
    nextLabel: 'Next',
    skipLabel: 'Skip',
    doneLabel: 'Done',
    menu: 'Menu',
    menuDes: 'Menu rendered in routing structure',
    collapse: 'Collapse',
    collapseDes: 'Expand and collapse the menu bar',
    tagsView: 'tagsView',
    tagsViewDes: 'Used to record routing history',
    tool: 'Tool',
    toolDes: 'Used to set up custom systems',
    query: 'Query',
    reset: 'Reset',
    shrink: 'Shrink',
    expand: 'Expand',
    confirmTitle: 'System hint',
    exportMessage: 'Are you sure you want to export data items?',
    importMessage: 'Are you sure you want to import data items?',
    createSuccess: 'Create success',
    updateSuccess: 'Update success',
    delMessage: 'Are you sure you want to delete the selected data?',
    delDataMessage: 'Are you sure you want to delete the data?',
    delNoData: 'Please select the data to be deleted',
    delSuccess: 'Delete successful',
    index: 'Index',
    id: 'ID',
    name: 'Name',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    remark: 'Remarks',
    operation: 'Operation',
    copy: 'Copy',
    copySuccess: 'Copy success',
    copyError: 'Copy failed',
    create: 'Create',
    export: 'Export',
    search: 'Search',
    creator: 'Creator',
    noValue: 'None',
    unknown: 'Unknown',
    warning: 'Warning',
    cancelSuccess: 'Cancel successful',
    delete: 'Delete',
    deleteSuccess: 'Delete successful'
  },
  lock: {
    lockScreen: 'Lock screen',
    lock: 'Lock',
    lockPassword: 'Lock screen password',
    unlock: 'Click to unlock',
    backToLogin: 'Back to login',
    entrySystem: 'Entry the system',
    placeholder: 'Please enter the lock screen password',
    message: 'Lock screen password error'
  },
  error: {
    noPermission: `Sorry, you don't have permission to access this page.`,
    pageError: 'Sorry, the page you visited does not exist.',
    networkError: 'Sorry, the server reported an error.',
    returnToHome: 'Return to home'
  },
  permission: {
    hasPermission: `Please set the operation permission label value`,
    hasRole: `Please set the role permission tag value`
  },
  setting: {
    projectSetting: 'Project setting',
    theme: 'Theme',
    layout: 'Layout',
    systemTheme: 'System theme',
    menuTheme: 'Menu theme',
    interfaceDisplay: 'Interface display',
    breadcrumb: 'Breadcrumb',
    breadcrumbIcon: 'Breadcrumb icon',
    collapseMenu: 'Collapse menu',
    hamburgerIcon: 'Hamburger icon',
    screenfullIcon: 'Screenfull icon',
    sizeIcon: 'Size icon',
    localeIcon: 'Locale icon',
    messageIcon: 'Message icon',
    tagsView: 'Tags view',
    logo: 'Logo',
    greyMode: 'Grey mode',
    fixedHeader: 'Fixed header',
    headerTheme: 'Header theme',
    cutMenu: 'Cut Menu',
    copy: 'Copy',
    clearAndReset: 'Clear cache and reset',
    copySuccess: 'Copy success',
    copyFailed: 'Copy failed',
    footer: 'Footer',
    uniqueOpened: 'Unique opened',
    tagsViewIcon: 'Tags view icon',
    reExperienced: 'Please exit the login experience again',
    fixedMenu: 'Fixed menu'
  },
  size: {
    default: 'Default',
    large: 'Large',
    small: 'Small'
  },
  login: {
    welcome: 'Welcome to the system',
    message: 'Backstage management system',
    tenantname: 'TenantName',
    username: 'Username',
    password: 'Password',
    code: 'verification code',
    login: 'Sign in',
    relogin: 'Sign in again',
    otherLogin: 'Sign in with',
    register: 'Register',
    checkPassword: 'Confirm password',
    remember: 'Remember me',
    hasUser: 'Existing account? Go to login',
    forgetPassword: 'Forget password?',
    tenantNamePlaceholder: 'Please Enter Tenant Name',
    usernamePlaceholder: 'Please Enter Username',
    passwordPlaceholder: 'Please Enter Password',
    codePlaceholder: 'Please Enter Verification Code',
    mobileTitle: 'Mobile sign in',
    mobileNumber: 'Mobile Number',
    mobileNumberPlaceholder: 'Plaease Enter Mobile Number',
    backLogin: 'back',
    getSmsCode: 'Get SMS Code',
    btnMobile: 'Mobile sign in',
    btnQRCode: 'QR code sign in',
    qrcode: 'Scan the QR code to log in',
    btnRegister: 'Sign up',
    SmsSendMsg: 'code has been sent',
    resetPassword: "Reset Password",
    resetPasswordSuccess: "Reset Password Success",
    invalidTenantName:"Invalid Tenant Name"
  },
  captcha: {
    verification: 'Please complete security verification',
    slide: 'Swipe right to complete verification',
    point: 'Please click',
    success: 'Verification succeeded',
    fail: 'verification failed'
  },
  router: {
    login: 'Login',
    home: 'Home',
    analysis: 'Analysis',
    workplace: 'Workplace'
  },
  analysis: {
    newUser: 'New user',
    unreadInformation: 'Unread information',
    transactionAmount: 'Transaction amount',
    totalShopping: 'Total Shopping',
    monthlySales: 'Monthly sales',
    userAccessSource: 'User access source',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    estimate: 'Estimate',
    actual: 'Actual',
    directAccess: 'Airect access',
    mailMarketing: 'Mail marketing',
    allianceAdvertising: 'Alliance advertising',
    videoAdvertising: 'Video advertising',
    searchEngines: 'Search engines',
    weeklyUserActivity: 'Weekly user activity',
    activeQuantity: 'Active quantity',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  workplace: {
    welcome: 'Hello',
    happyDay: 'Wish you happy every day!',
    toady: `It's sunny today`,
    notice: 'Announcement',
    project: 'Project',
    access: 'Project access',
    toDo: 'To do',
    introduction: 'A serious introduction',
    shortcutOperation: 'Quick entry',
    operation: 'Operation',
    index: 'Index',
    personal: 'Personal',
    team: 'Team',
    quote: 'Quote',
    contribution: 'Contribution',
    hot: 'Hot',
    yield: 'Yield',
    dynamic: 'Dynamic',
    push: 'push',
    follow: 'Follow'
  },
  form: {
    input: 'Input',
    inputNumber: 'InputNumber',
    default: 'Default',
    icon: 'Icon',
    mixed: 'Mixed',
    textarea: 'Textarea',
    slot: 'Slot',
    position: 'Position',
    autocomplete: 'Autocomplete',
    select: 'Select',
    selectGroup: 'Select Group',
    selectV2: 'SelectV2',
    cascader: 'Cascader',
    switch: 'Switch',
    rate: 'Rate',
    colorPicker: 'Color Picker',
    transfer: 'Transfer',
    render: 'Render',
    radio: 'Radio',
    button: 'Button',
    checkbox: 'Checkbox',
    slider: 'Slider',
    datePicker: 'Date Picker',
    shortcuts: 'Shortcuts',
    today: 'Today',
    yesterday: 'Yesterday',
    aWeekAgo: 'A week ago',
    week: 'Week',
    year: 'Year',
    month: 'Month',
    dates: 'Dates',
    daterange: 'Date Range',
    monthrange: 'Month Range',
    dateTimePicker: 'DateTimePicker',
    dateTimerange: 'Datetime Range',
    timePicker: 'Time Picker',
    timeSelect: 'Time Select',
    inputPassword: 'input Password',
    passwordStrength: 'Password Strength',
    operate: 'operate',
    change: 'Change',
    restore: 'Restore',
    disabled: 'Disabled',
    disablement: 'Disablement',
    delete: 'Delete',
    add: 'Add',
    setValue: 'Set value',
    resetValue: 'Reset value',
    set: 'Set',
    subitem: 'Subitem',
    formValidation: 'Form validation',
    verifyReset: 'Verify reset',
    remark: 'Remark'
  },
  watermark: {
    watermark: 'Watermark'
  },
  table: {
    table: 'Table',
    index: 'Index',
    title: 'Title',
    author: 'Author',
    createTime: 'Create time',
    action: 'Action',
    pagination: 'pagination',
    reserveIndex: 'Reserve index',
    restoreIndex: 'Restore index',
    showSelections: 'Show selections',
    hiddenSelections: 'Restore selections',
    showExpandedRows: 'Show expanded rows',
    hiddenExpandedRows: 'Hidden expanded rows',
    header: 'Header'
  },
  action: {
    create: 'Create',
    add: 'Add',
    del: 'Delete',
    delete: 'Delete',
    edit: 'Edit',
    update: 'Update',
    preview: 'Preview',
    more: 'More',
    sync: 'Sync',
    save: 'Save',
    detail: 'Detail',
    export: 'Export',
    import: 'Import',
    generate: 'Generate',
    logout: 'Login Out',
    test: 'Test',
    typeCreate: 'Dict Type Create',
    typeUpdate: 'Dict Type Eidt',
    dataCreate: 'Dict Data Create',
    dataUpdate: 'Dict Data Eidt',
    fileUpload: 'File Upload'
  },
  dialog: {
    dialog: 'Dialog',
    open: 'Open',
    close: 'Close'
  },
  sys: {
    api: {
      operationFailed: 'Operation failed',
      errorTip: 'Error Tip',
      errorMessage: 'The operation failed, the system is abnormal!',
      timeoutMessage: 'Login timed out, please log in again!',
      apiTimeoutMessage: 'The interface request timed out, please refresh the page and try again!',
      apiRequestFailed: 'The interface request failed, please try again later!',
      networkException: 'network anomaly',
      networkExceptionMsg:
        'Please check if your network connection is normal! The network is abnormal',

      errMsg401: 'The user does not have permission (token, user name, password error)!',
      errMsg403: 'The user is authorized, but access is forbidden!',
      errMsg404: 'Network request error, the resource was not found!',
      errMsg405: 'Network request error, request method not allowed!',
      errMsg408: 'Network request timed out!',
      errMsg500: 'Server error, please contact the administrator!',
      errMsg501: 'The network is not implemented!',
      errMsg502: 'Network Error!',
      errMsg503: 'The service is unavailable, the server is temporarily overloaded or maintained!',
      errMsg504: 'Network timeout!',
      errMsg505: 'The http version does not support the request!',
      errMsg901: 'Demo mode, no write operations are possible!'
    },
    app: {
      logoutTip: 'Reminder',
      logoutMessage: 'Confirm to exit the system?',
      menuLoading: 'Menu loading...'
    },
    exception: {
      backLogin: 'Back Login',
      backHome: 'Back Home',
      subTitle403: "Sorry, you don't have access to this page.",
      subTitle404: 'Sorry, the page you visited does not exist.',
      subTitle500: 'Sorry, the server is reporting an error.',
      noDataTitle: 'No data on the current page.',
      networkErrorTitle: 'Network Error',
      networkErrorSubTitle:
        'Sorry, Your network connection has been disconnected, please check your network!'
    },
    lock: {
      unlock: 'Click to unlock',
      alert: 'Lock screen password error',
      backToLogin: 'Back to login',
      entry: 'Enter the system',
      placeholder: 'Please enter the lock screen password or user password'
    },
    login: {
      backSignIn: 'Back sign in',
      mobileSignInFormTitle: 'Mobile sign in',
      qrSignInFormTitle: 'Qr code sign in',
      signInFormTitle: 'Sign in',
      signUpFormTitle: 'Sign up',
      forgetFormTitle: 'Reset password',

      signInTitle: 'Backstage management system',
      signInDesc: 'Enter your personal details and get started!',
      policy: 'I agree to the xxx Privacy Policy',
      scanSign: `scanning the code to complete the login`,

      loginButton: 'Sign in',
      registerButton: 'Sign up',
      rememberMe: 'Remember me',
      forgetPassword: 'Forget Password?',
      otherSignIn: 'Sign in with',

      // notify
      loginSuccessTitle: 'Login successful',
      loginSuccessDesc: 'Welcome back',

      // placeholder
      accountPlaceholder: 'Please input username',
      passwordPlaceholder: 'Please input password',
      smsPlaceholder: 'Please input sms code',
      mobilePlaceholder: 'Please input mobile',
      policyPlaceholder: 'Register after checking',
      diffPwd: 'The two passwords are inconsistent',

      userName: 'Username',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      email: 'Email',
      smsCode: 'SMS code',
      mobile: 'Mobile'
    }
  },
  profile: {
    user: {
      title: 'Personal Information',
      username: 'User Name',
      nickname: 'Nick Name',
      mobile: 'Phone Number',
      email: 'User Mail',
      dept: 'Department',
      posts: 'Position',
      roles: 'Own Role',
      sex: 'Sex',
      man: 'Man',
      woman: 'Woman',
      createTime: 'Created Date'
    },
    info: {
      title: 'Basic Information',
      basicInfo: 'Basic Information',
      resetPwd: 'Reset Password',
      userSocial: 'Social Information'
    },
    rules: {
      nickname: 'Please Enter User Nickname',
      mail: 'Please Input The Email Address',
      truemail: 'Please Input The Correct Email Address',
      phone: 'Please Enter The Phone Number',
      truephone: 'Please Enter The Correct Phone Number'
    },
    password: {
      oldPassword: 'Old PassWord',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      oldPwdMsg: 'Please Enter Old Password',
      newPwdMsg: 'Please Enter New Password',
      cfPwdMsg: 'Please Enter Confirm Password',
      diffPwd: 'The Passwords Entered Twice No Match'
    }
  },
  cropper: {
    selectImage: 'Select Image',
    uploadSuccess: 'Upload Success',
    modalTitle: 'Avatar upload',
    okText: 'Confirm and upload',
    btn_reset: 'Reset',
    btn_rotate_left: 'Counterclockwise rotation',
    btn_rotate_right: 'Clockwise rotation',
    btn_scale_x: 'Flip horizontal',
    btn_scale_y: 'Flip vertical',
    btn_zoom_in: 'Zoom in',
    btn_zoom_out: 'Zoom out',
    preview: 'Preview'
  },
  member: {
    enterprise: {
      create: {
        title: 'Create Enterprise',
        subtitle: 'Fill in enterprise information, complete verification after creation to unlock advanced features',
        basicInfo: 'Enterprise Information',
        basicInfoDesc: 'Please fill in the basic registration information',
        legalInfo: 'Legal Representative',
        legalInfoDesc: 'Please fill in the legal representative information',
        contactInfo: 'Contact Information',
        contactInfoDesc: 'Used to receive verification results and business notifications',
        licenseTitle: 'Business License',
        licenseOptional: 'Optional',
        licenseDesc: 'Uploading a business license can speed up the verification process',
        tipTitle: 'Creation Tips',
        tipContent: 'After creating an enterprise, you will become the owner, you can invite members and complete enterprise verification to use advanced features.',
        confirmTitle: 'Confirm Creation',
        confirmContent: 'After submission, the enterprise will be created and you will become the owner.',
        confirmButton: 'Confirm',
        cancelButton: 'Check Again',
        submitButton: 'Create Enterprise',
        success: 'Enterprise created successfully'
      }
    }
  },
  routes: {
    member: {
      member: 'Member',
      memberUser: 'Member',
      memberEnterprise: 'Enterprise Certification'
    },
    seal: {
      seal: 'E-Seal',
      sealManage: 'Seal Management',
      templateManage: 'Contract Templates',
      signTaskManage: 'Signing Tasks',
      batchTaskManage: 'Batch Tasks',
      apiKeyManage: 'API Keys'
    }
  },
  // E-Seal Module
  seal: {
    common: {
      module: 'E-Signature'
    },
    seal: {
      // 使用通用键
      // name: 'Seal Name',
      type: 'Seal Type',
      preview: 'Seal Preview',
      // status: 'Seal Status',
      // remark: 'Remarks',
      enableSeal: 'Enable Seal',
      disableSeal: 'Disable Seal',
      revokeSeal: 'Revoke Seal',
      deleteConfirm: 'Are you sure to delete this seal?',
      operationSuccess: 'Operation successful',
      authorizationManage: 'Authorization Management',
      usageLog: 'Usage Log'
    },
    authorization: {
      title: 'Seal Authorization',
      user: 'Authorized User',
      // 使用通用键 common.startTimeText 和 common.endTimeText
      // startTime: 'Start Time',
      // endTime: 'End Time',
      // 使用通用键 common.remark
      // remark: 'Remarks'
    },
    template: {
      // 使用通用键
      // title: 'Contract Template',
      // name: 'Template Name',
      description: 'Template Description',
      file: 'Template File',
      upload: 'Upload Template',
      previewTemplate: 'Preview Template',
      formFields: 'Form Fields',
      // createTemplate: 'Create Template',
      batchGuide: {
        title: 'Batch contract creation',
        desc: 'Click "Batch Launch" in the operation column to create multiple contracts from the same template at once.',
        link: 'Go to Batch Tasks'
      },
      index: {
        title: 'Contract Template Management',
        name: 'Template Name',
        createTime: 'Create Time',
        updateTime: 'Update Time',
        status: 'Status',
        operation: 'Operation'
      },
      form: {
        title: {
          create: 'Create Contract Template',
          update: 'Edit Contract Template'
        },
        name: {
          label: 'Template Name',
          placeholder: 'Please enter template name',
          required: 'Template name is required'
        },
        file: {
          label: 'Template File',
          placeholder: 'Please upload template file',
          required: 'Please upload template file',
          tip: 'Only PDF files less than 10MB are allowed'
        },
        remark: {
          label: 'Remark',
          placeholder: 'Please enter remark'
        }
      },
      preview: {
        title: 'Template Preview',
        empty: 'No preview content available'
      },
      designer: {
        title: 'Online Template Designer',
        save: 'Save',
        cancel: 'Cancel',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        fitWidth: 'Fit Width',
        prevPage: 'Previous Page',
        nextPage: 'Next Page',
        controlTools: 'Control Tools',
        propertySettings: 'Property Settings',
        name: 'Control Name',
        toolbox: 'Control Toolbox',
        properties: 'Property Settings',
        controlName: 'Control Name',
        controlType: 'Control Type',
        required: 'Required',
        defaultValue: 'Default Value',
        options: 'Options',
        optionsPlaceholder: 'One option per line',
        description: 'Description',
        selectControl: 'Please select a control',
        pdfLoading: 'Loading PDF document...',
        loadingPage: 'Loading page {page}...',
        unnamedField: 'Unnamed field',
        messages: {
          addSuccess: 'Field added successfully',
          deleteConfirm: 'Are you sure you want to delete this field?',
          deleteSuccess: 'Field deleted successfully',
          saveSuccess: 'Template saved successfully',
          saveFailed: 'Failed to save template',
          saveFailedHint:
            'Could not save the template. The data may be invalid or inconsistent with signatories. Please check that each field is assigned to a signatory and try again, or contact your administrator.',
          noSignatoriesForFields:
            'Cannot save form fields without signatories. Please configure signatories for the template first.',
          signatoryMissing:
            'These controls have no signatory: {names}. Assign a signatory to each control before saving.',
          signatoryInvalid:
            'The signatory for "{name}" is invalid or has changed. Please select a signatory again.',
          importSuccess: 'Fields imported successfully',
          exportSuccess: 'Fields exported successfully',
          noFieldsToExport: 'No fields to export',
          invalidImportData: 'Invalid import data format'
        }
      }
    },
    signTask: {
      title: 'Sign Task Management',
      taskName: 'Task Name',
      taskStatus: 'Task Status',
      draft: 'Draft',
      formFilling: 'Form Filling',
      signing: 'Signing',
      // Smart status display (distinguish "my action needed" vs "waiting for others")
      waitingMeToFillForm: 'To Fill',
      waitingOthersToFillForm: 'Others Filling',
      waitingMeToSign: 'To Sign',
      waitingOthersToSign: 'Others Signing',
      processing: 'Processing',
      completed: 'Completed',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      revoked: 'Revoked',
      expired: 'Expired',
      detail: 'Detail',
      preview: 'Preview',
      sign: 'Sign',
      template: 'Contract Template',
      deadline: 'Deadline',
      participants: 'Participants',
      participantName: 'Name',
      participantMobile: 'Mobile',
      signPosition: 'Sign Position',
      positionSet: 'Set',
      positionNotSet: 'Not Set',
      addParticipant: 'Add Participant',
      designPosition: 'Design Position',
      detailTitle: 'Sign Task Detail',
      participantList: 'Participant List',
      signTime: 'Sign Time',
      downloadSignedFile: 'Download Signed File',
      downloadTip: 'Click to download the signed file',
      downloadDisabledTip: 'Task incomplete. Download available after all participants sign',
      deleteTip: 'Delete this sign task',
      deleteDisabledTip: 'Only completed, cancelled, rejected, or expired tasks can be deleted',
      cancel: 'Cancel Task',
      cancelTip: 'Cancel this sign task',
      cancelDisabledTip: 'Only tasks in form filling or signing status can be cancelled',
      cancelConfirm: 'Are you sure you want to cancel this sign task?',
      reject: 'Reject',
      rejectTip: 'Reject signing this task',
      rejectDisabledTip: 'Current status does not allow rejection',
      rejectReason: 'Rejection Reason',
      rejectReasonPlaceholder: 'Please enter rejection reason',
      rejectConfirm: 'Are you sure you want to reject this task?',
      previewTitle: 'Document Preview',
      previewPageInfo: 'Page {current} of {total}',
      pdfLoading: 'PDF is loading, please wait...',
      page: 'Page',
      participantStatusLabel: 'Participant Status',
      taskInfo: 'Task Information',
      signParticipants: 'Sign Participants',
      progress: 'Progress',
      signNow: 'Sign Now',
      positionDesignerTitle: 'Sign Position Designer',
      savePositions: 'Save Positions',
      createTask: 'Create Sign Task',
      updateTask: 'Update Sign Task',
      addParticipantWarning: 'Please add at least one participant',
      participantInfoWarning: "Participant's name and mobile cannot be empty",
      createSuccess: 'Created successfully',
      noFileWarning: 'No file associated with this task, cannot preview',
      noFileToSignWarning: 'No file associated with this task, cannot sign',
      getDetailFailed: 'Failed to get task details',
      noSignedFileWarning: 'Signed file does not exist',
      selectPositionMessage: 'Selected sign position for {name}',
      savePositionsSuccess: 'Sign positions saved successfully',
      openSignWindowFailed: 'Failed to open sign window: ',
      signSuccess: 'Document signed successfully!',
      validation: {
        taskNameRequired: 'Task name cannot be empty',
        templateRequired: 'Please select a contract template',
        deadlineRequired: 'Please select a deadline',
        participantsRequired: 'Please add at least one participant',
        operationFailed: 'Operation failed, please try again'
      },
      participant: {
        status: {
          pending: 'Pending',
          signed: 'Signed',
          rejected: 'Rejected'
        }
      },
      participantStatus: {
        pending: 'Pending',
        signed: 'Signed',
        rejected: 'Rejected'
      },
      participantLabel: 'Participant',
      autoLayout: 'Auto Layout',
      clearAll: 'Clear All',
      currentSelected: 'Currently Selected',
      designTip: 'Please click on the PDF to set the signature position for this participant, or use the auto layout feature.',
      positionDetail: 'Position Detail',
      pageNumber: 'Page Number',
      xCoordinate: 'X Coordinate',
      yCoordinate: 'Y Coordinate',
      width: 'Width',
      height: 'Height',
      label: 'Label',
      positionLabel: 'Position Label',
      onlineSign: 'Online Document Signing',
      totalPages: 'Total {total} pages',
      sealSelectedGuide: 'Selected seal "{name}", click on PDF page to place seal',
      noDocumentContent: 'No document content available',
      clickToPlaceSeal: 'Click to place seal',
      sealSelection: 'Signature/Seal Selection',
      selected: 'Selected',
      pleaseSelectSeal: 'Please select a seal',
      sealDeleted: 'Seal deleted',
      emptyDocumentUrl: 'Document URL is empty, cannot preview',
      sealPermissionError: 'Failed to get seals: Insufficient permissions, please contact administrator to assign "seal:sign-task:sign" permission',
      userNotLoggedIn: 'Failed to get seals: User not logged in',
      getSealError: 'Failed to get seals',
      pleaseSelectSealFirst: 'Please select a seal first',
      pleaseAddSealFirst: 'Please add a seal to the document first',
      signFailed: 'Signing failed',
      noAvailableSeals: 'No available seals',
      noSealsCreated: 'You have not created any seals yet',
      goToSealManagementTip: 'Please go to <strong>Seal Management</strong> page to create seals first',
      goCreateSeal: 'Create Seal',
      waitingOperation: 'Waiting Operation',
      clickPdfToPlaceSeal: 'Please click on the PDF page on the left to place the seal',
      ready: 'Ready',
      sealsAddedReady: 'Added {count} seals, ready to sign',
      startSigning: 'Start Signing',
      selectSealAndPlace: 'Please select a seal first, then place it on the PDF',
      sealManagementGuide: 'Signing Instructions',
      dragToAdjustPosition: 'Drag placed seals to adjust position',
      clickToSelectSeal: 'Normal Mode: Select seal from right panel and drag to PDF',
      adjustSealSize: 'Perforation Mode: Drag seal to perforation zone, auto-covers all pages',
      clickDeleteToRemove: 'Hover seal to show delete button, click to remove',
      signDocument: 'Sign Document',
      positionSetForParticipant: 'Position set for {name}',
      noParticipantsToSet: 'No participants to set position for',
      clearAllPositionsConfirm: 'Are you sure you want to clear all positions?',
      allPositionsCleared: 'All positions cleared',
      positionSaved: 'Position saved',
      dragSealToPdf: 'Please drag the seal to the PDF page',
      dragging: 'Dragging',
      sealDragged: 'Seal moved to new position',
      selectSealAndDrag: 'Please select a seal first, then drag it to the PDF',
      dragSealHere: 'Drag seal here',
      sealSelectedDragTip: 'Selected seal "{name}", please drag it to the PDF page',
      sealPlacedSuccess: 'Seal "{name}" placed successfully',
      sealOutOfBounds: 'Seal cannot be placed outside PDF page boundaries',
      invalidDropArea: 'Please drag the seal to within the PDF page',
      sealPositionAdjusted: 'Seal position adjusted to fit within page boundaries',
      // Perforation seal related texts
      normalMode: 'Normal Seal',
      perforationMode: 'Perforation Seal',
      modeSwitch: 'Seal Mode',
      perforationGuide: 'Perforation seal will be displayed on all pages, drag to the right perforation zone',
                  dragToPerforationZone: 'This area is for perforation signing, please drag and drop the seal here',
        perforationZoneHint: 'This area is for perforation signing, please drag and drop the seal here',
        perforationSealAlreadyExists: 'A seal already exists in the perforation zone, please remove it before adding a new one',
        sealOverlapDetected: 'Seal position overlaps with existing seal, please adjust position and try again',
      perforationSealPlaced: 'Perforation seal placed on {count} pages',
      performanceWarning: 'Document has many pages ({pages} pages), may affect performance, please operate with caution',
      perforationDeleteConfirm: 'Deleting perforation seal will remove seals from all pages, confirm deletion?',
      onlyVerticalAdjustment: 'Perforation seal can only be adjusted vertically',
      perforationSealPlacedSuccess: 'Perforation seal "{name}" placed successfully on {pages} pages',
      perforationSealDeleted: 'Perforation seal deleted',
      perforationSealPositionAdjusted: 'Perforation seal position adjusted automatically',
      perforationSealOutOfBounds: 'Please drag the perforation seal to the perforation zone',
      // New signing related messages
      noValidSealSelected: 'No valid seal found, please ensure seals are properly placed',
      perforationSignProcessing: 'Processing perforation seal signing...',
      perforationSignSuccess: 'Perforation seal signed successfully!',
      
      // Pure frontend PDF editor related
      pureFrontendPdfEditor: 'Pure Frontend PDF Signing',
      pureFrontendMode: 'Pure Frontend Mode',
      realTimeEditing: 'Real-time Editing',
      autoSaved: 'Auto Saved',
      editingTools: 'Editing Tools',
      untitledTask: 'Untitled Task',
      instantSign: 'Instant Sign',
      livePreview: 'Live Preview',
      stopPreview: 'Stop Preview',
      fullPreview: 'Full Preview',
      compareVersions: 'Compare Versions',
      download: 'Download',
      clearAllSeals: 'Clear All Seals',
      sealCount: 'Added {count} seals',
      availableSeals: 'Available Seals',
      initSuccess: 'Initialization successful',
      
      // Loading status texts
      loading: {
        initializing: 'Initializing...',
        checkingPermissions: 'Checking permissions...',
        loadingPdf: 'Loading PDF...',
        renderingPdf: 'Rendering PDF...',
        loadingSeals: 'Loading seals...',
        loadingDraft: 'Loading draft...'
      },
      
      // Status texts
      status: {
        processing: 'Processing',
        completed: 'Completed',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        expired: 'Expired',
        unknown: 'Unknown Status'
      },
      
      // Error messages
      error: {
        taskNotInProgress: 'Task is not in progress, cannot sign',
        taskNotAvailable: 'Task has been revoked, rejected or expired, cannot operate',
        notParticipant: 'You are not a participant of this task',
        permissionCheckFailed: 'Permission check failed',
        noViewPermission: 'No view permission',
        noSignPermission: 'No sign permission',
        pdfLoadFailed: 'PDF loading failed',
        initFailed: 'Initialization failed',
        sealLoadFailed: 'Seal loading failed',
        noPdfLoaded: 'No PDF document loaded',
        signFailed: 'Signing failed',
        downloadFailed: 'Download failed'
      },
      
      // Warning messages
      warning: {
        noAvailableSeals: 'No available seals',
        sealLoadFailed: 'Seal loading failed',
        sealOutOfBounds: 'Seal position out of bounds',
        cannotSign: 'Cannot sign at the moment',
        pleaseAddSeal: 'Please add a seal first'
      },
      
      // Success messages
      success: {
        sealAdded: 'Seal "{name}" added successfully',
        sealRemoved: 'Seal "{name}" removed',
        allSealsCleared: 'All seals cleared',
        signCompleted: 'Signing completed',
        downloadCompleted: 'Download completed'
      },
      
      // Confirmation dialogs
      confirm: {
        title: 'Operation Confirmation',
        instantSign: 'Are you sure to perform instant signing? This operation cannot be undone.',
        clearAllSeals: 'Are you sure to clear all seals?'
      },
      
      // Information messages
      info: {
        previewFeatureComingSoon: 'Preview feature coming soon',
        pureFeModifyAllowed: 'Pure frontend mode allows re-editing'
      },
      
      // Metadata
      metadata: {
        signedDocument: 'Signed Document',
        systemName: 'Electronic Signature System',
        digitalSignature: 'Digital Signature'
      },
      
      // Form editing related
      sealMode: 'Seal Mode',
      formMode: 'Form Mode',
      hybridMode: 'Hybrid Mode', 
      
      // Mode descriptions
      sealModeDesc: 'Only show seal tools for adding electronic seals to PDF',
      formModeDesc: 'Only show form tools for filling PDF form fields',
      hybridModeDesc: 'Show both seal and form tools for complete PDF editing',
      
      singlePageView: 'Single Page View',
      multiPageView: 'Multi Page View', 
      singlePageViewDesc: 'Display one page at a time for focused editing',
      multiPageViewDesc: 'Display all pages simultaneously for overview', 
      detectFormFields: 'Detect Form Fields',
      clearAllFormFields: 'Clear All Fields',
      formFieldCount: 'Added {count} fields',
      formFieldsDetected: 'Detected {count} form fields',
      formFieldDetectionFailed: 'Form field detection failed',
      formFieldRemoved: 'Field "{name}" removed',
      allFormFieldsCleared: 'All form fields cleared',
      clearAllFormFieldsConfirm: 'Are you sure to clear all form fields?',
      modeChanged: 'Switched to {mode}',
      detectingFormFields: 'Detecting form fields...',
      noPdfLoaded: 'No PDF document loaded',
      
      // Page navigation related
      previousPage: 'Previous Page',
      nextPage: 'Next Page',
      pageIndicator: '{current}/{total}',
      jumpToThisPage: 'Jump to This Page',
      togglePageView: 'Toggle View Mode',
      viewModeChanged: 'Switched to {mode}',
      formFieldAdded: 'Field "{name}" added',
      
      // Business logic enhancement related
      taskDetails: 'Task Details',
      taskId: 'Task ID',
      initiator: 'Initiator',
      currentUser: 'Current User',
      permissions: 'Permissions',
      canView: 'Can View',
      canSign: 'Can Sign',
      canEdit: 'Can Edit',
      canDownload: 'Can Download',
      restrictedAccess: 'Restricted Access',
      moreActions: 'More Actions',
      saveAsDraft: 'Save as Draft',
      exportSettings: 'Export Settings',
      operationHistory: 'Operation History',
      resetAllConfirm: 'Are you sure to reset all content? This will clear all seals and form fields.',
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: ' days ago',
      
      // Error messages enhancement
      alreadySigned: 'You have already signed this task',
      initiatorCannotSign: 'Initiator cannot sign their own task',
      taskExpired: 'Task has expired',
      noEditPermission: 'No edit permission',
      draftSaveFailed: 'Draft save failed',
      
      // Success messages enhancement
      draftSaved: 'Draft saved',
      settingsExported: 'Settings exported',
      resetCompleted: 'Reset completed',
      
      // Loading states enhancement
      savingDraft: 'Saving draft...',
      
      // Confirmation dialogs enhancement
      
      // Information tips enhancement
      historyFeatureComingSoon: 'Operation history feature coming soon',
      
      // File processing and synchronization related
      uploadingPdf: 'Uploading PDF file...',
      syncingStatus: 'Synchronizing signature status...',
      verifyingIntegrity: 'Verifying file integrity...',
      loadingDraft: 'Loading draft...',
      
      // Error messages - File processing
      integrityVerificationFailed: 'File integrity verification failed',
      
      // Warning messages - Draft management
      draftSavedLocally: 'Network error, draft saved locally',
      
      // Success messages - Draft management  
      draftLoaded: 'Draft loaded successfully',
      
      // Information tips - Draft management
      localDraftLoaded: 'Draft loaded from local storage',
      
      // Form submission
      submitForm: 'Submit Form',
      updateForm: 'Update Form',
      submitSuccess: 'Submit successfully',
      updateSuccess: 'Update successfully',
      loadFailed: 'Loading failed',
      unknownStage: 'Unknown stage',
      contactSupport: 'Please contact system administrator or technical support',
      
      // Form filled completion notice
      formFilledSuccessTitle: 'Form Filled Successfully!',
      formFilledSuccessSubtitle: 'You have successfully submitted the form data. You can return to the list or view the filled content.',
      formFilledNotice: 'Next Steps',
      formFilledNoticeContent: 'You can return anytime to view and modify the form data. After all participants complete the form, you can proceed to sign.',
      waitingOthersToFillFormHint: 'Waiting for other participants to fill out the form before signing',
      backToList: 'Back to List',
      viewFormData: 'View Form Data',
      canModifyFormData: 'You can view and modify the form data',
      goToSign: 'Go to Sign',
      
      // Direct signing mode notice
      needSignTitle: 'Please Use Sign Function',
      needSignSubtitle: 'This task requires your signature',
      needSignNotice: 'Signature Notice',
      needSignNoticeContent: 'Please click "Go to Sign" button to use the dedicated signing page to complete the signature.',
      
      // Read-only mode
      viewOnlyMode: 'Read-only mode: Form data cannot be modified'
    }
  },
  'OAuth 2.0': 'OAuth 2.0'
}
